

// Tiny per-device pulse bus. Socket handlers publish on every arrival;
// each device card's dot subscribes by deviceID. No Redux, no re-render
// churn — just a direct event the moment data or a twin lands.

const listeners = new Map();   // deviceID -> Set<fn>

export function subscribePulse(deviceID, fn) {
    if (!listeners.has(deviceID)) listeners.set(deviceID, new Set());
    listeners.get(deviceID).add(fn);
    return () => {
        const set = listeners.get(deviceID);
        if (set) {
            set.delete(fn);
            if (set.size === 0) listeners.delete(deviceID);
        }
    };
}

export function pulseDevice(deviceID, timestamp) {
    const set = listeners.get(deviceID);
    if (!set) return;
    for (const fn of set) fn(timestamp || Date.now());
}